import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import styles from './styles.scss'

const TEMP_IMAGE = 'https://kwalify-media.s3.amazonaws.com/media/uploads/modem/KMVR500vAU-F_nmqvrp'

class OrderSummaryItemLarge extends PureComponent {
  static propTypes = {
    icon: PropTypes.string,
    iconColor: PropTypes.string,
    image: PropTypes.string,
    title: PropTypes.string,
    subtitle: PropTypes.string,
    primaryInfo: PropTypes.string,
    secondaryInfo: PropTypes.string,
    children: PropTypes.node,
    extraClass: PropTypes.string,
  }

  static defaultProps = {
    icon: '',
    iconColor: '$primary_color',
    image: TEMP_IMAGE,
    title: null,
    subtitle: null,
    primaryInfo: null,
    secondaryInfo: null,
    children: null,
    extraClass: '',
  }

  render() {
    const iconTypes = {
      plan: 'kgn-icon-dashboard',
      truck: 'kgn-icon-truck',
      house: 'kgn-icon-house-wireless',
      person: 'kgn-icon-user',
      identification: 'kgn-icon-drivers-license-o',
      none: '',
    }

    const {
      icon,
      iconColor,
      image,
      title,
      subtitle,
      primaryInfo,
      secondaryInfo,
      children,
      extraClass,
    } = this.props

    if (title === null || !primaryInfo) {
      // secondary info is allowed to be null
      return null
    }
    const iconClass = iconTypes[icon]
    const iconColorStyle = {
      color: iconColor,
    }

    return (
      <div className={extraClass}>
        {
          icon ? <i className={`${iconClass} ${styles.icon}`} style={iconColorStyle} /> :
          <img className={styles.image} src={image} alt={title} />
        }
        <div className={styles.itemContainer}>
          <div className={styles.heading}>
            <h2>{title}</h2>
            { subtitle &&
              <div className={styles.itemInfoSecondary} dangerouslySetInnerHTML={{ __html: subtitle }} />
            }
          </div>
          { primaryInfo &&
            <div className={styles.itemInfoMain}>{primaryInfo}</div>
          }
          <div className={`secondaryInfo ${styles.itemInfoSecondary}`}>{secondaryInfo}</div>
          <div className={styles.children}>{ children }</div>
        </div>
      </div>
    )
  }
}

export default OrderSummaryItemLarge



// WEBPACK FOOTER //
// ./components/OrderSummaryItemLarge/index.jsx